// extracted by mini-css-extract-plugin
export default {"main":"I_-z"};